export enum SearchModeEnum {
  EVENT = 'event',
  /**
   * An event search refined by artist combines both modes rather than one
   * winning: the gallery title is the event name with a "by {artist}" byline.
   */
  EVENT_ARTIST = 'eventArtist',
  ARTIST = 'artist',
  GROUP_BY_EVENT = 'groupByEvent',
  STACK = 'stack',
  RECENTLY_VIEWED = 'recentlyViewed',
  CURATED_SET = 'curatedSet',
  STANDARD = 'standard',
  CONTRIBUTOR = 'contributor',
  SEARCH_BY_IMAGE = 'searchByImage',
  MORE_LIKE_THIS = 'moreLikeThis',
}

/**
 * The semantic kind of search being performed.
 *
 * Deliberately just the kind. Which parameters a mode leaves available is a
 * separate question, answered by `availableSearchParametersFor` — see the note
 * there.
 */
export type SearchMode = Readonly<{
  kind: SearchModeEnum;
}>;
